<template>
  <div class="full">
    <div class="container">
        <br>
       
     <!-- <img :src="'/imgs/error_wire.png'" alt="error" class="imgs"> -->
     <div class="left">
   <h4 class="text-left mt-2 font-extrabold tracking-wide text-9xl  font-sans text-black ">Oops! We couldn't find that Page.</h4>
   <p class="text-left text-gray-500 text-lg font-light">Please check the URL</p>
    <!-- <p class="text-center text-gray-500"></p> -->
    <div class="text-left">
    <button type="button" class="  py-1 px-3 mt-3  rounded " style="background-color:#57269B" >
     <a href="" class="text-white no-underline">Take me back</a>
       </button>
    </div>
     </div>
     <div class="">
    <!-- <img :src="'/imgs/error12.png'" alt="error" class=""> -->
    <br/>
    </div>
   </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>
 .full{
    /* background-color: #f6f6f6; */
    background-image: url('/imgs/error404img.png');
    height:100vh;
    background-size: cover;
    overflow: hidden;
}
.left{
    margin-top: 300px;
}

</style>